import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { exportCsv, exportToExcel } from '../../../services/export';
import {
    Grid,
    Cell,
    Card,
    CardTitle,
    CardText,
    LinearProgress,
    DatePicker,
    Button,
    DataTable,
    TableHeader,
    TableRow,
    TableColumn,
    TableBody,
    TablePagination,
} from 'react-md';

import FlatOrIconButton from '../../../components/atoms/flatOrIconButton';
import TableActions from '../../../components/molecules/tableActions';
import PieChart from '../../../components/molecules/charts/pieChart';
import { baseUrl } from '../../../services/endpoints';
import { optionsGET } from '../../../services/options';

// using CSV export helper instead of react-export-excel

const ProgramaAcademico = () => {

    const [loading, setLoading] = useState(false);
    const [academics_loading, setAcademicLoading] = useState(false);
    const [start_date, setStartDate] = useState(moment());
    const [end_date, setEndDate] = useState(moment());
    const [state, setState] = useState({
        excelData: [],
        data: [],
        operation: '',
        slicedData: [],
        academics: {
            data: [],
            total: '0',
        },
    });

    const styles = {
        card: {
            borderRadius: '2px',
            marginBottom: '2rem',
        },
    };

    // =======================================================
    /// 
    // =======================================================
    const handlePagination = (start, rowsPerPage) => {
        setState(prev => ({
            ...prev,
            slicedData: prev.data.slice(start, start + rowsPerPage)
        }));
    };
    
    // =======================================================
    /// 
    // =======================================================
    const getData = async () => {
        setLoading(true);
        setAcademicLoading(true);
        setState( prev => ({
            ...prev,
            data: [],
            slicedData: []
        }));

        //return fetch('http://52.14.65.118:4000/user_traces/academics', optionsGET())
        const params = `?start_at=${moment(start_date).format('YYYY-MM-DD')}&end_at=${moment(end_date).format('YYYY-MM-DD')}`;
        const resp = await fetch(`${baseUrl}user_traces/academics${params}`, optionsGET());
        // console.log(await resp.clone(),await resp.clone().json());
        const response = resp.ok ? await resp.json() : [];
        
        let data;
        let excelData;

        excelData = response.filter(({ result }) => !/error/ig.test(result))
            .map(({ username, department, inserted_at }) =>
                ({
                    department,
                    username,
                    inserted_at: moment(inserted_at).format('DD/MM/YYYY HH:mm')
                }));

        data = _.orderBy(_.map(response, element => {
            let ref = {
                'Programa académico': null,
                'Usuario': null,
                'Fecha': null,
            };

            if (element.department) ref['Programa académico'] = (element.department) ? element.department : 'Sin información';
            if (element.username) ref['Usuario'] = element.username;
            if (element.operation) ref['Operación'] = element.operation;
            if (element.result) ref['Resultado'] = element.result;
            if (element.data) ref['Información'] = element.data;
            if (element.inserted_at) ref['Fecha'] = moment(element.inserted_at).format('DD/MM/YYYY HH:mm');

            return ref;
        }, rps => moment(rps.Fecha).unix()));

        data.sort((a, b) => {
            const keyA = new Date(a.Fecha);
            const keyB = new Date(b.Fecha);
            if (keyA > keyB) return -1;
            if (keyA < keyB) return 1;
            return 0;
        });

        const academics = response.map(item => ({ name: item.department || 'Desconocido' }))
            .reduce(function (arr, item) {
                let found = false;

                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].name === item.name) {
                        found = true;
                        arr[i].count++;
                    }
                }

                if (!found) {
                    item.count = 1;
                    arr.push(item);
                }

                return arr;
            }, []);

        
        setState(prev => ({
            ...prev,
            excelData,
            data,
            slicedData: data.slice(0, 10),
            academics: {
                data: academics,
                total: academics.reduce((total, element) => {
                    return total + element.count;
                }, 0),
            },
        }));

        setLoading(false);
        setAcademicLoading(false);
            
    }

    // =======================================================
    /// 
    // =======================================================
    useEffect(() => {
        getData();
    }, []);

    // Export helpers with graceful behavior and user feedback
    const handleExportXlsx = async (data, filename) => {
        if (!data || !Array.isArray(data) || data.length === 0) {
            alert('No hay registros disponibles, selecciona fechas válidas y dale clic en el botón BUSCAR para cargar la información');
            return;
        }

        setLoading(true);
        try {
            await exportToExcel(data, filename);
        } catch (err) {
            console.error('exportToExcel failed', err);
            try {
                exportCsv(data, filename.replace(/\.xlsx?$/, '.csv'));
            } catch (e) {
                console.error('Export CSV fallback failed', e);
                alert('Ocurrió un error al exportar el reporte');
            }
        } finally {
            setLoading(false);
        }
    };
        
    return (
        <Grid style={{width:"100%"}}>
            <Cell size={12}>

                <Card style={styles.card}>
                    <CardTitle title={state.academics.total} subtitle='Préstamos por programa académico' />
                    <CardText>
                        {academics_loading && (<LinearProgress id='academicsProgress' />)}

                        {state.academics.data && (
                            <Grid>
                                <Cell size={12}>
                                    <PieChart
                                        width={400}
                                        height={220}
                                        data={state.academics.data}
                                        dataKey='count'
                                    />
                                </Cell>
                            </Grid>
                        )}

                    </CardText>
                </Card>

                <Card tableCard>
                    <TableActions
                        title='Préstamos por Programa académico'
                        count={0}
                        onResetClick={getData} />

                    <Grid>
                        <DatePicker
                            id='date-picker-auto-ok'
                            label='Desde'
                            autoOk
                            className='md-cell md-cell--bottom'
                            name="historicDataStartAt"
                            value={state.historicDataStartAt}
                            onChange={(value, date) =>
                                setStartDate(moment(date).format('YYYY-MM-DD'))
                            }
                            locales='es-ES'
                        />
                        <DatePicker
                            id='date-picker-auto-ok'
                            label='Hasta'
                            autoOk
                            className='md-cell md-cell--bottom'
                            name="historicDataEndAt"
                            value={state.historicDataEndAt}
                            onChange={(value, date) =>
                                setEndDate(moment(date).format('YYYY-MM-DD'))
                            }
                            locales='es-ES'
                        />
                        <Button
                            type='submit'
                            className='md-cell md-cell--bottom'
                            onClick={getData}
                            primary
                            flat>
                            Buscar
                        </Button>
                    </Grid>

                    <Button
                        style={{ marginLeft: 20 }}
                        raised
                        primary
                        iconEl={<FlatOrIconButton
                            iconChildren='folder'
                            style={{ color: '#fff' }}>{loading ? 'Cargando...' : '»Exportar CSV'}</FlatOrIconButton>}
                        onClick={() => {
                            if (!state.excelData || !Array.isArray(state.excelData) || state.excelData.length === 0) {
                                alert('No hay registros disponibles, selecciona fechas válidas y dale clic en el botón BUSCAR para cargar la información');
                                return;
                            }
                            exportCsv(state.excelData, 'Prestamos_por_Programa_academico.csv');
                        }}
                    />
                    <Button
                        style={{ marginLeft: 8 }}
                        raised
                        primary
                        iconEl={<FlatOrIconButton
                            iconChildren='insert_drive_file'
                            style={{ color: '#fff' }}>{loading ? 'Cargando...' : '»Exportar XLSX'}</FlatOrIconButton>}
                        onClick={() => handleExportXlsx(state.excelData || [], 'Prestamos_por_Programa_academico.xlsx')}
                    />

                    {loading && <LinearProgress id='usersProgress' />}

                    <DataTable baseId='dynamic-content-desserts'>
                        {state.data.length == 0 && (
                            <tbody>
                                <tr>
                                    <td style={{ textAlign: 'center', padding: '10px' }}>Sin Registro</td>
                                </tr>
                            </tbody>
                        )}
                        {state.slicedData.length > 0 && (
                            <React.Fragment>
                                <TableHeader>
                                    <TableRow>
                                        {state.slicedData.length > 0 && Object.keys(state.slicedData[0]).map((header, i) => (
                                            <TableColumn key={header}>{header}</TableColumn>
                                        ))}
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {state.slicedData.map((item, i) => (
                                        <TableRow key={item.id}>
                                            {Object.keys(item).map(key => (
                                                <TableColumn key={key}>{item[key]}</TableColumn>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                                <TablePagination
                                    rows={state.data.length}
                                    rowsPerPageLabel='Registros por página'
                                    onPagination={handlePagination}
                                />
                            </React.Fragment>
                        )}
                    </DataTable>
                </Card>
            </Cell>
        </Grid>
    );
};

export default ProgramaAcademico;